"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Question = _interopRequireDefault(require("./Question"));

var _Answer = _interopRequireDefault(require("./Answer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Result =
/*#__PURE__*/
function (_Component) {
  _inherits(Result, _Component);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Result).call(this, props));
    _this.state = {
      score: 0
    };
    return _this;
  }

  _createClass(Result, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var score = this.state.score;
      var _this$props = this.props,
          correctAns = _this$props.correctAns,
          answers = _this$props.answers;
      var tmpScore = score;
      answers.map(function (answer, index) {
        if (answer == correctAns[index]) {
          tmpScore = tmpScore + 1;
        }

        return _this2.setState({
          score: tmpScore
        });
      });
    }
  }, {
    key: "render",
    value: function render() {

	    document.querySelector('.page-content').scrollTo(0, 0); // values are x,y-offset


      var score = this.state.score;
      var _this$props2 = this.props,
          questions = _this$props2.questions,
          answers = _this$props2.answers,
          correctAns = _this$props2.correctAns;
      var renderQuestion = questions.map(function (question, index) {
        return _react.default.createElement("div", {
          className: "result-question",
          key: index
        }, _react.default.createElement("div", {
          className: "row"
        }, _react.default.createElement("div", {
          className: "col-12 col"
        }, _react.default.createElement(_Question.default, {
          currentQuestion: question
        }))), _react.default.createElement("div", {
          className: "row"
        }, _react.default.createElement("div", {
          className: "col-12 col"
        }, _react.default.createElement(_Answer.default, {
          questionType: question.questionType,
          answers: question.answers,
          userAnswers: answers,
          renderInResult: true,
          correctAns: correctAns,
          qIdx: index
        }))));
      });

      
      var renderResult = _react.default.createElement("div", null, _react.default.createElement("h1", null, " Dit resultat: ", _react.default.createElement("span", {
        "className": "quiz-badge secondary"
      }, score, "/", questions.length)));
      
      var renderResultRating = _react.default.createElement("div", null, _react.default.createElement("h3", null, `${score < 10 ? 'Du har stadig meget du kan lære om Gedser. Du kan læse mere om Gedser under seværdigheder' : score < 21 ? 'Du er ikke helt ukendt i Gedser. Dog kan du stadig lære en del inden du bliver eksperte' : score < 25 ? 'Du er næsten Gedser Eksperte' : 'Tillykke du er Gedser Eksperte'  }`));
      
      return _react.default.createElement("div", {
        className: "result-container"
      },renderResult, renderResultRating, renderQuestion);
    }
  }]);

  return Result;
}(_react.Component);

Result.propTypes = {
  correctAns: _propTypes.default.array,
  answers: _propTypes.default.array,
  questions: _propTypes.default.array
};
var _default = Result;
exports.default = _default;